document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ryzon-withdrawal-form');
  if (!form) return;

  const endpoint = form.dataset.endpoint;
  const step1 = document.getElementById('wf-step-1');
  const step2 = document.getElementById('wf-step-2');
  const nextBtn = document.getElementById('wf-next');
  const backBtn = document.getElementById('wf-back');
  const submitBtn = document.getElementById('wf-submit');
  const successEl = document.getElementById('withdrawal-success');
  const errorBanner = document.getElementById('withdrawal-error-banner');
  const datetimeInput = document.getElementById('wf-datetime');

  function isGerman() {
    const locale = form.querySelector('[name="locale"]')?.value || 'de';
    return locale.startsWith('de');
  }

  function validateStep1() {
    const required = ['name', 'orderNumber', 'email'];
    const msg = isGerman() ? 'Dieses Feld ist erforderlich.' : 'This field is required.';
    let valid = true;
    required.forEach(name => {
      const input = form.querySelector(`[name="${name}"]`);
      if (!input) return;
      const errorEl = input.closest('.withdrawal-form__field')?.querySelector('.withdrawal-form__field-error');
      if (!input.value.trim()) {
        if (errorEl) errorEl.textContent = msg;
        valid = false;
      } else {
        if (errorEl) errorEl.textContent = '';
      }
    });
    return valid;
  }

  function populateReview() {
    const locale = isGerman() ? 'de-DE' : 'en-GB';
    const formatted = new Date().toLocaleString(locale, {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
    datetimeInput.value = formatted;

    const reason = form.querySelector('[name="reason"]').value.trim();
    document.getElementById('wf-review-name').textContent = form.querySelector('[name="name"]').value;
    document.getElementById('wf-review-order').textContent = form.querySelector('[name="orderNumber"]').value;
    document.getElementById('wf-review-email').textContent = form.querySelector('[name="email"]').value;
    document.getElementById('wf-review-reason').textContent = reason || '—';
    document.getElementById('wf-review-datetime').textContent = formatted;
  }

  nextBtn.addEventListener('click', () => {
    if (!validateStep1()) return;
    populateReview();
    step1.hidden = true;
    step2.hidden = false;
  });

  backBtn.addEventListener('click', () => {
    step2.hidden = true;
    step1.hidden = false;
  });

  form.addEventListener('submit', async e => {
    e.preventDefault();
    errorBanner.hidden = true;

    const formData = new FormData(form);
    const data = {};
    formData.forEach((value, key) => {
      data[key] = value;
    });

    submitBtn.setAttribute('aria-busy', 'true');
    submitBtn.disabled = true;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const json = await res.json();

      if (res.ok && json.success) {
        form.hidden = true;
        step2.hidden = true;
        successEl.hidden = false;
      } else {
        step2.hidden = true;
        errorBanner.hidden = false;
      }
    } catch {
      step2.hidden = true;
      errorBanner.hidden = false;
    } finally {
      submitBtn.removeAttribute('aria-busy');
      submitBtn.disabled = false;
    }
  });
});
